import { useMutation } from "@grandvisionhq/graphql";
import { UPDATE_PERSONAL_DETAILS } from "../../../../operations/mutations/operations/mutations/update-personal-details.js";
const useUpdatePreferredStore = ({
  onError,
  onCompleted
}) => {
  const [mutationCallback, mutation] = useMutation(UPDATE_PERSONAL_DETAILS, {
    onCompleted,
    onError(error) {
      onError?.(error, "stores.storeDetailsRoot.preferredStoreUpdate.error");
    }
  });
  return {
    data: mutation?.data?.updateB2CPersonalDetails.preferredStore ?? null,
    loading: mutation?.loading,
    error: mutation?.error,
    updatePersonalDetails: async (preferredGlobalStoreId, userId) => {
      await mutationCallback({
        variables: {
          customerId: userId,
          input: {
            preferredGlobalStoreId
          }
        }
      });
    }
  };
};
export {
  useUpdatePreferredStore as default
};
//# sourceMappingURL=use-update-preferred-store.js.map
